import React, { useEffect, useState } from "react";
import { useNavigate, useLocation, Navigate } from "react-router-dom";
import { jwtDecode } from "jwt-decode";
import { toast } from "react-toastify";

export function ProtectedRoute({ children }) {
  const [isAuthenticated, setIsAuthenticated] = useState(null);
  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const token = localStorage.getItem("token");
    if (!token) {
      setIsAuthenticated(false);
      return;
    }

    try {
      const decodedToken = jwtDecode(token);
      const currentTime = Date.now() / 1000;
      if (decodedToken.exp < currentTime) {
        localStorage.removeItem("token");
        toast.error("Session Expired! You will be logged out");
        // Use window.location for more reliable redirect after toast shows
        setTimeout(() => {
          window.location.href = "/login";
        }, 2500); // Slightly longer delay to ensure toast is visible
        setIsAuthenticated(false);
      } else {
        setIsAuthenticated(true);
      }
    } catch (error) {
      // Handle invalid token format or other decoding errors
      toast.error("Invalid Token Format!");
      localStorage.removeItem("token");
      setTimeout(() => {
        window.location.href = "/login";
      }, 2500); // Slightly longer delay to ensure toast is visible
      setIsAuthenticated(false);
    }
  }, [navigate]);

  if (isAuthenticated === null) {
    // Still checking authentication
    return null;
  }

  if (!isAuthenticated) {
    // No need to render ToastContainer here, it should be in App.js
    return <Navigate to="/login" state={{ from: location }} replace />;
  }

  return children;
}
